<template>
  <div class="cube-wrapper" :style="{paddingLeft: margin + 'px', paddingRight: margin + 'px'}">
    <ul class="cube-list flex" :style="{margin: -(itemMargin / 2) + 'px'}">
      <li class="flex-1" v-for="(v, i) in cubeList" :key="i" :style="{margin: itemMargin / 2 + 'px'}">
        <img class="img" :src="v.src" alt="背景" />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    permutation: {
      type: Number,
      default: 2
    },
    margin: {
      type: Number,
      default: 0
    },
    itemMargin: {
      type: Number,
      default: 0
    },
    cubeList: {
      type: Array,
      default: () => [
        {
          src:
            "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
          url: ""
        },
        {
          src:
            "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
          url: ""
        }
      ]
    }
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.cube-list {
  font-size: 0;
  li {
    .img {
      width: 100%;
    }
  }
}
</style>
